import React from "react";
import theuz from "../theuz/imgTheuz/theuz.png";
import "./p-t.css";

function Privacy(){
    return(
        <>
              <header className="header-t-p">
                <div className="header-tp-container">
                  <a href="/">
                    <img src={theuz} alt="" />
                  </a>
                </div>
              </header>
              <main>
                <section className="tp-section">
                    <h1>Política de Privacidade (THEUZ SOLUTIONS)</h1>
        
                    <p>Esta Política de Privacidade descreve como a THEUZ SOLUTIONS coleta, utiliza, armazena e protege as informações fornecidas pelos usuários e visitantes de nosso website.</p>
        
                    <h2>1. Coleta de Informações</h2>
                    <ul>Coletamos informações para entender suas necessidades e fornecer a melhor experiência e serviços. As informações que podemos coletar incluem:
                        <li><strong>Informações de Identificação (quando fornecidas):</strong> Nome, endereço de e-mail e telefone, fornecidos quando o usuário entra em contato para solicitar um orçamento ou informações.</li>
                        <li><strong>Dados de Navegação:</strong> Endereço IP, tipo de navegador, tempo de permanência no site, páginas visitadas e dados de localização aproximada (através de cookies e ferramentas de análise, como Google Analytics).</li>
                    </ul>
        
                    <h2>2. Uso das Informações Coletadas</h2>
                    <ul>As informações coletadas são usadas para os seguintes propósitos:
                        <li><strong>Comunicação:</strong> Para responder a solicitações de orçamento, dúvidas e informações enviadas pelo usuário via e-mail.</li>
                        <li><strong>Melhoria dos Serviços:</strong> Para analisar o desempenho do website e entender o interesse dos usuários em nossos serviços (Websites, Landing Pages, Apps) e melhorar a oferta.</li>
                        <li><strong>Marketing:</strong> Envio ocasional de e-mails sobre novos serviços, promoções ou outras informações que possam ser do interesse do usuário, caso ele tenha consentido.</li>
                    </ul>
        
                    <h2>3. Compartilhamento de Informações</h2>
                    
                    <ul>A THEUZ SOLUTIONS se compromete a não vender, alugar ou transferir suas informações pessoais a terceiros. As informações podem ser compartilhadas apenas nos seguintes casos:
                        <li>Com fornecedores de serviços (ex: hospedagem de site, ferramentas de e-mail marketing), estritamente para a operação dos serviços e sob rigoroso acordo de confidencialidade.</li>
                        <li>Quando exigido por lei ou ordem judicial.</li>
                    </ul>
        
                    <h2>4. Segurança de Dados</h2>
                    <p>Adotamos medidas de segurança técnicas e administrativas razoáveis para proteger as informações coletadas, incluindo o uso de criptografia SSL (HTTPS) no website para proteger a transmissão de dados.</p>
        
                    <h2>5. Cookies</h2>
                    <p>Nosso website utiliza cookies para melhorar a experiência de navegação e realizar análises de tráfego. O usuário pode optar por desativar os cookies nas configurações de seu navegador. No entanto, isso pode afetar a funcionalidade de algumas áreas do site.</p>
        
                    <h2>6. Direitos do Usuário</h2>
                    <ul>O usuário tem o direito de solicitar a qualquer momento:
                        <li>Acesso e confirmação da existência de tratamento dos seus dados.</li>
                        <li>Retificação de dados incompletos, inexatos ou desatualizados.</li>
                        <li>Exclusão dos seus dados pessoais.</li>
                    </ul>
        
                    <h2>7. Contato</h2>
                    <p>Para dúvidas sobre esta Política ou sobre o tratamento dos seus dados, entre em contato através do nosso e-mail oficial (o mesmo fornecido na seção "Fale Conosco").</p>
        
                </section>
              </main>
            </>
    )
}

export default Privacy;